import React from 'react'
import { Link } from 'react-router-dom'

const Error = () => {
  return (
    <>
        <section className="lyt-section typ-page-404 custom-margin-top">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 text-center">
                        <h1 className="mergB4">404</h1>
                        <div className="contant-box-404">
                            <h3 className="bs-para typ30 typ600 mb-2">
                                Oops! Page Not Found
                            </h3>
                            <p className="bs-para typ30 typ600 mb-4">the page you are looking for not avaible!</p>
                            <Link to="/" className="bs-btn">Go to Home</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Error